import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface Preference {
    ownerUuid: string
    realm: string
    identifier: string
    value: string
}

interface UpdateEntityPreferenceForm {
    realm: string
    identifier: string
    value: string
}

interface DeleteEntityPreferenceForm {
    realm: string
    identifier: string
}

interface PreferencesApiReturn {
    fetchEntityPreferences: (uuid: string) => Promise<Preference[]>
    updateEntityPreference: (uuid: string, form: UpdateEntityPreferenceForm) => Promise<Preference>
    deleteEntityPreference: (uuid: string, form: DeleteEntityPreferenceForm) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): PreferencesApiReturn => ({
    fetchEntityPreferences: (uuid: string): Promise<Preference[]> => axios
        .get<{ data: Array<Preference> } >(`/api/admin/preferences/${uuid}`)
        .then(response => response.data.data),

    updateEntityPreference: (uuid: string, form: UpdateEntityPreferenceForm): Promise<Preference> => axios
        .put<{ data: Preference } >(`/api/admin/preferences/${uuid}`, form)
        .then(response => response.data.data),

    deleteEntityPreference: async (uuid: string, form: DeleteEntityPreferenceForm): Promise<void> => {
        await axios.delete<void>(`/api/admin/preferences/${uuid}`, {data: form});
    },
});
